/**
 * Help (?) per page (Arnold, 08.10.: „ja zu deinem Vorschlag“): one short text per Event › Planung
 * page, per Planung page of the organisation and per area (H1). Each help id has the keys
 * `planner.help.<id>.what` („Was Sie hier tun“), `.step_1` … `.step_<n>` („So geht's“, at most 3)
 * and `.hint` („Gut zu wissen“); the value here is the number of steps.
 *
 * @type {Readonly<Record<string, 1 | 2 | 3>>}
 */
export const PLANNER_HELP = Object.freeze({
  overview: 3,
  tasks: 3,
  budget: 3,
  vendors: 3,
  sponsors_sponsors: 3,
  sponsors_packages: 3,
  sponsors_benefits: 3,
  costs_receipts: 3,
  costs_payments: 3,
  documents: 3,
  reporting_perhead: 3,
  reporting_trend: 3,
  reporting_waterfall: 3,
  reporting_result: 3,
  org_budgets: 3,
  org_tasks: 3,
  org_vendors: 3,
  org_sponsors: 3,
  org_payments: 3,
  settings_trades: 3,
  settings_statuses: 3,
  settings_lists: 3,
  settings_sponsoring: 2,
  settings_finances: 2,
})

/**
 * The translation keys of one help text.
 *
 * @param {string} helpId
 * @returns {{ what: string, steps: string[], hint: string }}
 */
export function plannerHelpKeys(helpId) {
  const prefix = `planner.help.${helpId}`
  const count = PLANNER_HELP[helpId] ?? 0

  return {
    what: `${prefix}.what`,
    steps: Array.from(
      { length: count },
      (_, index) => `${prefix}.step_${index + 1}`,
    ),
    hint: `${prefix}.hint`,
  }
}

/**
 * The browser remembers per person and help id that the page or area was visited (H3).
 *
 * @param {string|number|null} userId
 * @param {string} helpId
 * @returns {string}
 */
export function plannerHelpStorageKey(userId, helpId) {
  return `planner-help-seen:${userId ?? 'guest'}:${helpId}`
}

/**
 * Whether this is the first visit of the page or area — and remembers the visit, so the dot shows
 * on this visit only (H3: it goes after the first visit even if the (?) was not opened). Without
 * usable storage (private mode, blocked site data) there is no dot rather than one on every visit.
 *
 * @param {string|number|null} userId
 * @param {string} helpId
 * @returns {boolean}
 */
export function takePlannerHelpFirstVisit(userId, helpId) {
  const key = plannerHelpStorageKey(userId, helpId)

  try {
    if (window.localStorage.getItem(key) !== null) {
      return false
    }
    window.localStorage.setItem(key, new Date().toISOString())

    return true
  } catch {
    return false
  }
}
